const common = {
  "site.name": "高潮喷水完全指南",
  "site.subtitle": "科学性健康科普平台",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "footer.description": "致力于以科学、客观、尊重的态度传播性健康知识，帮助大众建立正确的身体认知与性健康意识。",
  "footer.quickLinks": "快速链接",
  "footer.resources": "资源",
  "footer.contact": "联系我们",
  "footer.copyright": "© 2026 高潮喷水完全指南 版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "使用条款",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.article": "文章",
  "breadcrumb.about": "关于我们",
  "cta.readMore": "阅读全文",
  "cta.viewAll": "查看全部",
  "cta.subscribe": "订阅",
  "category.all": "全部文章",
  "search.placeholder": "搜索文章...",
  "newsletter.title": "订阅我们的通讯",
  "newsletter.description": "获取最新性健康科普文章和专业知识，关爱自己的身体。",
  "newsletter.placeholder": "输入您的邮箱地址",
  "newsletter.subscribe": "免费订阅",
  "newsletter.privacy": "我们尊重您的隐私，绝不会分享您的信息。",
  "scrollTop": "回到顶部",
  "about.title": "关于我们",
  "about.intro": "品牌介绍",
  "about.reputation": "专业声誉",
  "about.contact": "联系方式",
  "notFound.title": "页面未找到",
  "notFound.description": "您访问的页面不存在或已被移除。",
  "notFound.goHome": "返回首页",
  "faq.title": "常见问题解答",
};

export default common;